<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="用户昵称">
            <el-input
              v-model="queryForm.userName"
              placeholder="请输入用户昵称"
              style="width: 187px"
              clearable
            />
          </el-form-item>
          <el-form-item label="手机尾号">
            <el-input
              v-model="queryForm.phone"
              placeholder="请输入手机尾号后四位"
              style="width: 187px"
              clearable
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="queryForm.status"
              clearable
              filterable
              placeholder="请选择用户状态"
            >
              <el-option
                v-for="item in storeList"
                :key="item.status"
                :label="item.label"
                :value="item.status"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select
              v-model="queryForm.userType"
              filterable
              clearable
              placeholder="请选择用户类型"
            >
              <el-option
                v-for="(item, index) in timeRangeList"
                :key="index.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="用户编号"
          prop="user_name"
          height="500"
        />
        <el-table-column
          align="center"
          label="用户类型"
          width="180"
        >
          <template #default="{ row }">
            <!-- <p>{{ userFit[row.user_type] }}</p> -->
             <span>{{ row.phone ? '正式用户' : '游客' }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="nick_name" label="用户昵称">
        </el-table-column>
        <el-table-column align="center" prop="finish_time" label="用户头像">
          <template #default="{ row }">
            <!-- <img :src="row.avatar" alt="" style="width: 70px; height: 70px;"> -->
             <el-image 
              v-if="row.avatar"
              style="width: 100px; height: 100px"
              :src="row.avatar"
              :preview-src-list="[row.avatar]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号">
          <template #default="{ row }">
            <p>{{ hidePhoneMiddle(row.phone) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建日期"
        >
          <template #default="{ row }">
            <p>{{ transTime(row.insert_time) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="注册日期">
            <template #default="{ row }">
            <p>{{ transTime(row.register_time) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          prop="refund_time"
        >
            <template #default="{ row }">
              <p>{{ statusFit[row.status] }}</p>
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-if="row.status == 1"
              @click="handleEdit(row)"
              v-hasPermi="['Island:userlist:block']"
            >
              <span>拉黑</span>
            </el-button>
            <el-button
              v-if="row.status == 2"
              size="small"
              type="info"
              @click="handleEdit(row)"
              v-hasPermi="['Island:userlist:removeblock']"
            >
              移除拉黑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getVisitorList, manageUpdateVisitorStatus } from "@/api/radio"
import { hidePhoneMiddle } from "@/utils/cutImgName"
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      hidePhoneMiddle,
      statusFit: {
        1: "正常",
        2: "拉黑",
      },
      userFit: {
        1: "正式用户",
        2: "游客",
      },
      storeList: [
        {
          status: 1,
          label: '正常'
        },
        {
          status: 2,
          label: '拉黑'
        }
      ],
      timeRangeList: [
        {
          value: '1',
          label: '正式用户'
        },
        {
          value: '2',
          label: '游客'
        }
      ],
      queryForm: {
        page: 1,
        pageSize: 10,
        userType: "",
        status: "",
        phone: "",
        userName: "",
        timeRange: "",
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    async fetchData() {
      // 这里发请求
      let params = {
        userName: this.queryForm.userName,
        phone: this.queryForm.phone,
        status: this.queryForm.status ? this.queryForm.status : '-1',
        userType: this.queryForm.userType ? this.queryForm.userType : -1,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      await getVisitorList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleEdit(row){
      let status = row.status == 1 ? 2 : 1
      let title = row.status == 1 ? '确认拉黑吗？' : '确认取消拉黑吗？'
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        manageUpdateVisitorStatus({
          id: row.id,
          status: status
        })
        .then((res) => {
          if (res && res.code) {
            this.fetchData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
        .catch((e) => {
          console.log(e);
        });
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
</style>